import * as actionTypes from './actionTypes.js';
export const selectedCreditorReducer = (state = null, action) => {
    switch (action.type) {
        case actionTypes.SELECT_CREDITOR:
            return action.payload.selected;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map